import React from 'react';
import Section from '../Section';
import Button from '../Button';
import IconWrapper from '../Icon';
import { AccentArrow } from '/react4xp/components/Svg/Others/Icons';


interface FrontPageHeroProps {
    title?: string;
    intro?: string;
    image?: { src: string; srcMedium?: string; srcMobile?: string; alt: string; };
    video?: string;
    productList?: { name: string, link: string }[];
    linkTitle?: string;
    ctaLink?: string;
    ctaText?: string;
}

export default function FrontPageHero({
    title,
    intro,
    image,
    video,
    productList,
    linkTitle,
    ctaLink,
    ctaText,
}: FrontPageHeroProps) {
    return (
        <>
            <Section
                bgColor='bg-beige-050'
                textColor='text-dark'
            >
                <div className="grid-container frontpage-hero">
                    <div className="grid-row frontpage-hero__wrapper">
                        <div className="c-12 frontpage-hero__header">
                            <h1 className="frontpage-hero__title">{title}</h1>
                            <p className='frontpage-hero__intro'>{intro}</p>

                            {image && (
                                <div className="frontpage-hero__image">
                                    <figure>
                                        <picture>
                                            <source srcSet={image.srcMobile} media="(max-width: 600px)" />
                                            <source srcSet={image.srcMedium} media="(max-width: 1240px)" />
                                            <img src={image.src} alt={image.alt} />
                                        </picture>
                                    </figure>
                                </div>
                            )}
                            {video && (
                                <div className="frontpage-hero__video">
                                    <video src={video} autoPlay muted playsInline loop>
                                    </video>
                                </div>
                            )}
                        </div>

                        <div className="c-12 start-md-3 c-md-8 frontpage-hero__product-list">

                            {linkTitle && (
                                <p className="frontpage-hero__product-title">{linkTitle || 'Our products'}</p>
                            )}
                            {productList && (
                                <ul className="product-list">
                                    {productList.map((product) => (
                                        <li key={product.name}>
                                            <IconWrapper IconComponent={AccentArrow} className='frontpage-hero__icon' iconSize='lg' />
                                            <a href={product.link} className='font-title'>{product.name}</a>
                                        </li>
                                    ))}
                                </ul>
                            )}
                            {ctaLink && (
                                <>
                                    <div className="frontpage-hero__line"></div>
                                    <Button className='frontpage-hero__product-all' href={ctaLink || '#'} color='primary' rightIcon='' size='md'>{ctaText || 'See all products'}</Button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </Section>
        </>
    )
}

